import {
    Component,
    OnInit,
    OnDestroy,
    ViewContainerRef,
    ViewChildren,
    ViewChild,
    QueryList,
    AfterViewInit,
} from '@angular/core';
import { MatTabGroup, MatTabChangeEvent } from '@angular/material/tabs';
import { Observable, Subscription } from 'rxjs';
import { Store, select } from '@ngrx/store';
import { RootState } from '../../root-store/root.state';
import { selectActiveSeSideComponentState } from '../redux/se-side-nav.selectors';
import { SeSideComponentType } from '../se-side-components/se-side-components-models';
import { ReportingComponentProps, SeSideService } from '../se-side.service';
import { ToolbarSliderOptions } from '../../se-toolbar/se-buttons-toolbar/types';
import { selectSeButtonsToolbarRightSlider } from '../../root-store/root.selectors';
import { seToolbarToggleRightSlider } from '../../se-toolbar/se-buttons-toolbar/redux/se-buttons-toolbar.actions';

@Component({
    selector: 'se-side-nav',
    templateUrl: './se-side-nav.component.html',
    styleUrls: ['./se-side-nav.component.scss'],
})
export class SeSideNavComponent implements AfterViewInit, OnInit,  OnDestroy {
    @ViewChildren('reportingContainer', { read: ViewContainerRef }) reportingContainer?: QueryList<ViewContainerRef>;

    @ViewChild('matTabGroup') matTabs: MatTabGroup | undefined;

    activeSideComponents$ = this.store.pipe(select(selectActiveSeSideComponentState));
    hideContent: boolean = false;
    reportingComponentSubscription?: Subscription;
    selectedTabIndex: number = 0;
    sideComponentType = SeSideComponentType;
    subscriptions: Subscription[] = [];
    rightSlider$: Observable<ToolbarSliderOptions>;
    show: boolean = true;
    closed: boolean = false;

    private handleTabContentVisibility: Map<boolean, (index: number) => void> = new Map<boolean, (index: number) => void>();

    constructor(private store: Store<RootState>, private seSide: SeSideService) {
        this.handleTabContentVisibility.set(true, this.showTabContent);
        this.handleTabContentVisibility.set(false, this.hideTabContent);
        this.rightSlider$ = this.store.select((state) => selectSeButtonsToolbarRightSlider(state));
    }

     ngOnInit() {
        const rightSub: Subscription = this.rightSlider$.subscribe((options) => {
            this.show = options.enabled;
            this.closed = options.enabled && !options.checked;
            if (this.closed) {
                this.unselectTabs();
            }

            if (this.selectedTabIndex === -1 && !this.closed) {
                this.selectFirstTab();
            }
        });
         this.subscriptions.push(rightSub);
     }

    private selectFirstTab() {
        this.selectedTabIndex = 0;
        this.hideContent = false;
    }

    private unselectTabs() {
        this.selectedTabIndex = -1;
        this.hideContent = true;
    }

    ngAfterViewInit() {
        this.reportingContainer.changes.subscribe((change: QueryList<ViewContainerRef>) => {
            if (change.first) {
                this.reportingComponentSubscription = this.listenForSideComponentChanges();
            } else {
                this.reportingComponentSubscription?.unsubscribe();
            }
        });
    }

    ngOnDestroy() {
        this.reportingContainer.forEach((ref) => ref.clear());
        this.reportingComponentSubscription?.unsubscribe();
        this.subscriptions.forEach((sub) => sub.unsubscribe());
    }

    private showTabContent = (index: number) => {
        this.selectedTabIndex = index;
    };

    private hideTabContent = (_: number) => {
        this.selectedTabIndex = -1;
    }

    onSelectedTabChange(showTabContent: MatTabChangeEvent) {
        this.handleTabContentVisibility.get(!this.hideContent)(showTabContent.index);
        setTimeout(() => {
            this.matTabs.realignInkBar(); // Serve altrimenti al primo avvio l'animazione non parte
        }, 0);
    }

    private toggleOneNoteSlider() {
        this.store.dispatch(seToolbarToggleRightSlider());
    }

    private listenForSideComponentChanges() {
        return this.seSide.reportingComponent$.subscribe((props) => {
            this.reportingContainer.forEach((ref) => ref.clear());

            if (props) {
                this.createReportingComponent(props);
            }
        });
    }

    private createReportingComponent(props: ReportingComponentProps<any>) {
        const component = this.reportingContainer.first?.createComponent(props.component);
        for (const [key, value] of Object.entries(props.inputs)) {
            component.instance[key] = value;
        }
    }

    onClick(tabIndex: number) {
         if (!!this.closed) {
            this.hideContent = false;
            this.toggleOneNoteSlider();
            this.selectedTabIndex = tabIndex;
            return;
        }

        if (this.selectedTabIndex === -1) {
            this.hideContent = false;
            this.toggleOneNoteSlider();
            this.selectedTabIndex = tabIndex;
            return;
        }

        if (this.selectedTabIndex === tabIndex) {
            this.hideContent = true;
            this.handleTabContentVisibility.get(!this.hideContent).apply(tabIndex);

            this.toggleOneNoteSlider();
            return;
        }
    }
}
